// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Factors_wrapper__19N17","content":"Factors_content__IaMmE"};